import { Button } from "@/components/ui/button";
import { HERO } from "@/constants/testIds";
import { ArrowRight, Zap } from "lucide-react";

export default function Hero({ onDonate, onPledge, stats }) {
  const pct = stats?.percent ?? 0;
  const raised = stats?.raised ?? 0;
  const goal = stats?.goal ?? 250000;
  const backers = stats?.backers ?? 0;

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-dot-matrix opacity-50 pointer-events-none" />
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: "url(https://images.unsplash.com/photo-1612630741022-b29ec17d013d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage: "linear-gradient(to bottom, rgba(0,0,0,0.7), transparent 85%)",
          WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,0.7), transparent 85%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 pt-16 pb-20 sm:pt-24 sm:pb-28 lg:pt-32 lg:pb-36">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-white/15 bg-slate-950/60 backdrop-blur-sm font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300 mb-8">
          <span className="w-2 h-2 bg-kinetic rounded-full pulse-dot" />
          Phase 01 — Fundraising Live
        </div>

        <h1 className="font-display font-black uppercase tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-8xl max-w-5xl">
          Reinventing the <span className="text-kinetic">last mile</span>, one route at a time.
        </h1>

        <p className="mt-8 max-w-2xl text-lg text-slate-300 leading-relaxed">
          Rally is a founder-led courier network built to put small shops and local shippers back in control of same-day delivery. We&apos;re raising to put the first fleet on the road. Back a tier, pledge your support, or just leave a note.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Button
            data-testid={HERO.donateBtn}
            onClick={onDonate}
            className="bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase tracking-wide rounded-none h-12 px-6 group"
          >
            Donate by Card <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            data-testid={HERO.pledgeBtn}
            onClick={onPledge}
            variant="outline"
            className="h-12 px-6 rounded-none border-white/30 bg-transparent hover:bg-white/5 hover:text-white font-bold uppercase tracking-wide"
          >
            <Zap className="mr-2 h-4 w-4 text-kinetic" /> Pledge Without Paying
          </Button>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 border border-white/10 max-w-3xl">
          {[
            ["Raised", `$${raised.toLocaleString()}`],
            ["Goal", `$${Number(goal).toLocaleString()}`],
            ["Backers", backers.toString()],
            ["% Complete", `${pct.toFixed(1)}%`],
          ].map(([k, v]) => (
            <div key={k} className="bg-slate-950 p-4 sm:p-5">
              <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{k}</div>
              <div className="font-display text-2xl sm:text-3xl font-bold mt-1 text-white">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
